
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.639 0l-.116.022-3.856 1.495L4.333 0 .26 1.372A.364.364 0 000 1.72v10.92c0 .202.159.361.361.361l.116-.022 3.856-1.495L8.667 13l4.073-1.372c.152-.05.26-.18.26-.347V.361A.358.358 0 0012.639 0zM8.667 11.556l-4.334-1.524V1.444l4.334 1.524v8.588z","fill":"#7A7A7A"}})])
          )
        }
      }
    